import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor, productName } from '../data/content';
import { checkoutFeatures, pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
type PricingProps = {
  /** Only the primary offer section carries the #offer anchor id */
  id?: string;
  titleId?: string;
};
export function Pricing({
  id,
  titleId = 'offer-title'
}: PricingProps) {
  return <section id={id} className="scroll-mt-4 bg-brand-deep px-4 py-12 md:py-16" aria-labelledby={titleId} data-id="element-152" data-mp="k9uoanru9juj">
      <div className="mx-auto max-w-xl" data-id="element-153" data-mp="6acv7w7ifkfd">
        <div className="text-center" data-id="element-154" data-mp="6dh61cfhdef0">
          <p className="text-[11px] font-black uppercase tracking-[.2em] text-accent-light md:text-xs" data-id="element-155" data-mp="abyh2720v91p">
            Special launch offer
          </p>
          <h2 id={titleId} className="mt-2 text-2xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-156" data-mp="2r3gedn0ftpi5">
            {productName}
          </h2>
        </div>

        <article className="mt-8 rounded-3xl border-4 border-accent bg-white p-6 shadow-2xl md:p-8" data-id="element-157" data-mp="2fodqdd3re4r7">
          <OfferLink href={offerAnchor} className="mx-auto max-w-[260px]" label={`${productName} offer`} data-id="element-158" data-mp="2apszi4aecxff">
            <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-159" data-mp="2opu0rkukq6vf" />
          </OfferLink>

          <p className="mt-6 text-center text-sm font-black uppercase tracking-wide text-brand-deep" data-id="element-160" data-mp="2tnvkm7ztqa7y">
            5 Complete Volumes + 5 Practical Bonuses
          </p>
          <p className="mt-2 text-center text-sm" data-id="element-161" data-mp="38e2tbw014evg">
            <span className="font-semibold text-slate-600" data-id="element-162" data-mp="33e821rccdn9v">Bonus value </span>
            <span className="font-bold text-slate-500 line-through decoration-red-600 decoration-2" data-id="element-163" data-mp="3hces4lb1uiyz">
              ${pricing.bonusValue} USD
            </span>
            <span className="ml-2 font-black uppercase text-brand" data-id="element-164" data-mp="3cbs6f95i3zop">Free</span>
          </p>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-165" data-mp="2a2a0le315n2p">
            Your complete collection includes:
          </p>
          <ul className="mx-auto mt-3 flex w-fit flex-col gap-2" data-id="element-166" data-mp="2j02eqex0mooi">
            {checkoutFeatures.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-brand-deep" data-id="element-167" data-mp="2nternrsc171f">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-dark" aria-hidden="true" data-id="element-168" data-mp="2sqexq2p6m9sj" />
                {item}
              </li>)}
          </ul>

          <p className="mt-8 text-center text-4xl font-black text-brand-deep" data-id="element-169" data-mp="32ouog4karh1i">
            ${pricing.price} <span className="text-base font-bold text-slate-500" data-id="element-170" data-mp="36qzkf9y7wprb">USD</span>
          </p>
          <p className="mt-1 text-center text-xs font-black uppercase tracking-wide text-brand" data-id="element-171" data-mp="18blc850d9hfk">
            One-time payment — instant access
          </p>
          <div className="mt-4" data-id="element-172" data-mp="1cerj9evazcn3">
            <Button href={checkoutUrl} size="lg" fullWidth subtext={`One-time payment of $${pricing.price} USD`} data-id="element-173" data-mp="14sw4nsndpaiz">
              Checkout — Get the complete bundle
            </Button>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-extrabold uppercase text-slate-600" data-id="element-174" data-mp="v32zpahqrtnp">
            <li className="flex items-center gap-1.5" data-id="element-175" data-mp="r32cb0co084i">
              <ZapIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-176" data-mp="1ns1p8so71y31" /> Instant Digital Delivery
            </li>
            <li className="flex items-center gap-1.5" data-id="element-177" data-mp="1isf662lopnmb">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-178" data-mp="1iqubmczde4og" /> 7-Day Guarantee
            </li>
            <li className="flex items-center gap-1.5" data-id="element-179" data-mp="19s8yixco3hv2">
              <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-180" data-mp="19rqtpcbxvvbj" /> Secure Payment
            </li>
          </ul>
        </article>
      </div>
    </section>;
}